import { pickCostApiValue } from "@repo/shared";
import type { CostType } from "@repo/shared/types";
import type { Localize } from "@/lib/i18n/use-localize";

export type ApiCostValue = {
  costTypeId: string;
  name: string;
  value: number | null;
  sourceKey: string | null;
};

export function computeApiCostValues(
  metadata: Record<string, unknown> | null,
  costTypes: CostType[],
  localize: Localize,
): ApiCostValue[] {
  return costTypes.map((costType) => {
    const picked = metadata ? pickCostApiValue(metadata, costType.apiKeys) : null;
    return {
      costTypeId: costType.id,
      name: localize(costType.nameI18n),
      value: picked?.value ?? null,
      sourceKey: picked?.sourceKey ?? null,
    };
  });
}
